import React, {useEffect, useRef, useState} from "react";
import {FileUploader} from "react-drag-drop-files";
import AnimateHeight from "react-animate-height";

import './style.css'

/* eslint import/no-webpack-loader-syntax: off */
import SvgTrash from "-!svg-react-loader!../../icons/trash-2.svg";

const MAX_SIZE_FILE = 100;
const fileTypes = ["JPG", "PNG", "PDF", "TIFF"];
export default function DropFile({show = true, classes, name = '', maxLength = 3,  files, setFiles}) {
    const inputFile = useRef(null);

    const [sizeError, setSizeError] = useState(false);
    const [typeError, setTypeError] = useState(false);
    const time = useRef(null);


    const clearError = () => {
        clearTimeout((time.current))
        time.current = setTimeout(() => {
            setSizeError(false);
            setTypeError(false);
            inputFile.current.value = '';
        }, 5000)
    }
    const onError = (error) => {
        if (error === 'size') setSizeError(true);
        else if (error === 'type') setTypeError(true);
        clearError();
    }
    const removeFile = (value) => {
        const newFiles = files.filter(item => item.id !== value);
        setFiles([...newFiles]);
        inputFile.current.value = '';
    }

    const handleChange = (value) => {
        const limitFiles = [...value].slice(0, maxLength - files.length);
        limitFiles.forEach(item => item.id = `${new Date().getTime()}${Math.random()}`)

        setFiles([...files, ...limitFiles])
    }

    useEffect(() => {
        inputFile.current = inputFile.current.querySelector('input[type=file]')
    }, [])

    return (
        <AnimateHeight
            className={classes}
            id="example-panel"
            duration={500}
            height={show ? 'auto' : 0}
        >
            <div className="n-drop-file" ref={inputFile}>
                <h6 className="n-drop-file__title">Drop files here or</h6>
                <FileUploader
                    name={name}
                    multiple={true}
                    disabled={files.length >= maxLength}
                    maxSize={MAX_SIZE_FILE}
                    types={fileTypes}
                    handleChange={handleChange}
                    onSizeError={() => onError('size')}
                    onTypeError={() => onError('type')}
                >
                    <button className="n-drop-file__select-files">Select files</button>
                </FileUploader>
            </div>
            <p className="n-drop-file__paragraph">Accepted file types: {fileTypes.join(', ').toLowerCase()} Max. file
                size: 100 MB, Max. files: 3.</p>
            {sizeError ?
                <p className="n-drop-file__error">File size is too big, max size file {MAX_SIZE_FILE} MB</p> : null}

            {typeError ?
                <p className="n-drop-file__error">
                    This type of file is not allowed. Must be one of the following: {fileTypes.join(', ').toLowerCase()}
                </p>
                : null}

            {files.length ?
                <ul className="n-drop-file__list-files">
                    {files.map(item => (
                        <li key={item.id}>
                            <button onClick={() => removeFile(item.id)}>
                                <SvgTrash/>
                            </button>
                            {item.name}
                        </li>
                    ))}
                </ul>
                : null}
        </AnimateHeight>
    )
}


// WEBPACK FOOTER //
// ./src/new-components/drop-file/index.js